export enum EPunchAuditAction {
    Add = 0,
    Update = 1,
    Delete = 2,
    AutoBreak = 3,
    Rounded = 4,
    AutoTransfer = 5,
    Error = 6,
    AutoSplitOnDayBoundry = 7,
    Exported = 8,
    ExportFailed = 9,
    SkipExport = 10,
    TimecardSequenceError = 11,
    MobileLog = 12,
    CustomRounded = 13,
    AddMissingPunch = 14,
    AcceptSuspense = 15,
    SuspenseTime = 16,
    RejectSuspense = 17,
    TimeFraud = 18,
    PPAAdjust = 19,
    IVRCall = 20,
}

export enum EAuditTypes {
    Punch,
    Expense,
    PPAExpense
}

export interface IPunchAudit {
    ChangeUserId: string
    ChangeUserName: string
    PreviousLocalDateTime: string
    PreviousDateTime: string
    ChangedLocalDateTime: string
    ChangedDateTime: string
    ActionDateTime: string
    PunchAuditAction: EPunchAuditAction
    Note: string,
    AuditType: EAuditTypes
}


